import React from "react";
import { useEffect, useState } from "react";
import Loader from "../../Components/Core/Loader";
import { getUserComment, deleteComment } from "../../Services/CommentService";
import UserCommentCard from "./UserCommentCard";
import ConfirmModal from "../../Components/Modals/ConfirmModal";
import { MessageSquare } from "lucide-react";
import { CheckRole } from "../../Services/AuthService";
import Notification from "../../Components/Core/Notification";
import MyConsultationReviews from "../../Components/Reviews/MyConsultationReviews";

const UserComments = () => {
  const [comments, setComments] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState(null);
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getUserComment();
      setComments(response);
      console.log(response);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "نظرات ثبت شده";
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    try {
      setIsDeleting(true);
      await deleteComment(id);
      setComments(comments.filter((comment) => comment.id !== id));
      setSnackbarMessage("دیدگاه با موفقیت حذف شد");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
    } catch (error) {
      console.log(error.message);
      setSnackbarMessage("خطا در حذف دیدگاه");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setIsDeleting(false);
    }
  };

  const confirmDelete = (id) => {
    setSelectedId(id);
    setOpenDialog(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedId) {
      await handleDelete(selectedId);
      setSelectedId(null);
    }
    setOpenDialog(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("fa-IR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  };

  return (
    <div className="pb-5 mb-5">
      <MyConsultationReviews />
      <h3 className="iran-sans color-blue fs-5">نظرات مقاله‌های من</h3>
      {loading ? (
        <Loader />
      ) : comments.length === 0 ? (
        <div className="text-center iran-sans" style={{ padding: "4rem 2rem" }}>
          <MessageSquare
            size={64}
            color="#053251"
            style={{ opacity: 0.3, marginBottom: "1rem" }}
          />
          <h4
            className="iran-sans"
            style={{ color: "#053251", marginBottom: "0.5rem" }}
          >
            نظری برای مقاله‌ها وجود ندارد
          </h4>
          <p className="iran-sans" style={{ color: "#6c757d" }}>
            شما هنوز برای مقاله‌ها نظری ثبت نکرده‌اید
          </p>
        </div>
      ) : (
        <>
          <div className="row">
            <span className="fs-3 iran-sans color-blue fw-bold highlight-box highlight-secondary mb-5">
              نظرات من
            </span>
          </div>
          <div className="row g-4">
            {comments.map((comment) => (
              <div key={comment.id} className="col-12 col-md-6">
                <UserCommentCard
                  comment={comment}
                  formatDate={formatDate}
                  // handleCheck={handleCheck}
                  confirmDelete={confirmDelete}
                  isDeleting={isDeleting}
                  CheckRole={CheckRole}
                  DestinationPage={"UserComments"}
                />
              </div>
            ))}
          </div>
        </>
      )}
      {/* Delete Confirmation Modal */}
      <ConfirmModal
        openDialog={openDialog}
        handleCloseDialog={() => setOpenDialog(false)}
        handleConfirm={handleConfirmDelete}
        text={["آیا از حذف این نظر مطمئن هستید؟"]}
        confirmText={"بله"}
        cancleText={"خیر"}
        title={"حذف نظر"}
      />
      <Notification
        openSnackbar={openSnackbar}
        snackbarMessage={snackbarMessage}
        snackbarSeverity={snackbarSeverity}
        setOpenSnackbar={setOpenSnackbar}
      />
    </div>
  );
};

export default UserComments;
